function Arrivals(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.162 21.494H5.839v1.975h20.323v-1.975zM16.688 11.977V10.25h1.722V8.53h-4.82v1.719h1.723v1.728c-4.27.35-7.627 3.92-7.627 8.278h16.628c0-4.358-3.358-7.928-7.627-8.279z"
        fill="#000"
      />
    </svg>
  )
}

export default Arrivals
